export default "__VITE_ASSET__C5RQg7TK__"